import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IPostcodeWeight } from '../interfaces/postcode-weight';
import { IPostcodeWeightFilter } from '../interfaces/postcode-weight-filter';
import { EditService } from './edit.service';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';

@Injectable({ providedIn: 'root' })
export class PostcodeWeightService extends EditService<IPostcodeWeight, IPostcodeWeightFilter> {
  url = '/api/postcodesweight';
  entityTitle = 'Postcode Weight';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  save(data: any): Promise<any> {
    let successMsg =
      typeof data.id != undefined && data.id != 0
        ? 'Postcode Weight updated.'
        : 'Postcode Weight added.';

    return this.handleRequest(
      this.http.post(`${this.url}` + '/save', data),
      this.handlersFactory.getForUpdate(this.entityTitle),
      successMsg,
    );
  }

  deleteWeight(data: any): Promise<any> {
    let successMsg = 'Postcode Weight deleted.';

    return this.handleRequest(
      this.http.post(`${this.url}` + '/deletepostcodeweight', data),
      this.handlersFactory.getForDelete(this.entityTitle),
      successMsg,
    );
  }

  downloadPostCodeWeighing(filter: any) {
    let params = this.constructHttpParams(filter);
    //console.log(params)
    let prom = this.http.get(this.url + '/download', { params: params, responseType: 'blob' });
    return prom;
  }
}
